"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MEDIA_QUERIES = {
    mobile: "(max-width: 767px)",
    aboveMobile: "(min-width: 768px)",
    desktop: "(min-width: 1025px)",
    tablet: "(max-width: 1023px) and (min-width: 768px)",
    preferesReducedMotion: "(prefers-reduced-motion: reduce)"
};
